import React, { useEffect } from 'react';
import _isEmpty from 'lodash/isEmpty';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useDispatch, useSelector } from 'react-redux';
import SideBarListStyles from '../../styles/SideBarListStyle';
import { showProgress, getTopicOfTheMonth } from '../../redux/actions/DealershipActions';
import Service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';
import { apiEndpoints } from '../../constants/apiEndpoints';

export default function SidebarListTOM({ filterArray }) {
  const classes = SideBarListStyles();
  const dispatch = useDispatch();

  const topicOfTheMonthSelectedDate = useSelector((state) => state.getTopicOfTheMonth.selectedDate);

  const fetchDataList = async () => {
    dispatch(showProgress(true));

    try {
      const response = await Service.get(apiEndpoints.TOM_DATES);
      dispatch(getTopicOfTheMonth('SET_DATES_LIST', response));
      if (!_isEmpty(response)) {
        handleListItemClick(response[0]);
      }
    } catch (err) {
      ErrorToast(err);
    }

    dispatch(showProgress(false));
  };

  useEffect(() => {
    fetchDataList();
  }, []);

  const myRefs = filterArray?.reduce((acc, val) => {
    acc[val.date] = React.createRef();
    return acc;
  }, {});

  useEffect(() => {
    myRefs[topicOfTheMonthSelectedDate?.date]?.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }, [topicOfTheMonthSelectedDate, filterArray]);

  const handleListItemClick = async (data = {}) => {
    dispatch(showProgress(true));

    if (!_isEmpty(data)) {
      dispatch(getTopicOfTheMonth('SET_DATE', data));
      try {
        const response = await Service.post(apiEndpoints.TOM_TOPICS_BY_DATES, { date: data.date });
        dispatch(getTopicOfTheMonth('SET_DATE_DATA', response));
        if (!_isEmpty(response)) {
          dispatch(getTopicOfTheMonth('SET_TOPIC_ID', response[0].id));
        }
        dispatch(showProgress(false));
      } catch (err) {
        ErrorToast(err);
      }
    }

    dispatch(showProgress(false));
  };

  return (
    <div className={classes.root}>
      <List component="nav" aria-label="secondary mailbox folder">
        {(filterArray || []).map((data) => (
          <div key={data.date} className={topicOfTheMonthSelectedDate.date === data.date ? classes.highlightItem : ''}>
            <ListItem
              id={`Item${data.date}`}
              ref={myRefs[data.date]}
              key={data.date}
              button
              selected={topicOfTheMonthSelectedDate.date === data.date}
              className={classes.listStyling}
              onClick={() => handleListItemClick(data)}
            >
              <ListItemText
                primary={
                  <div>
                    <p
                      className={`
                          ${
                            topicOfTheMonthSelectedDate.date === data.date
                              ? classes.listTextSelected
                              : classes.listTextNonSelected
                          }
                        `}
                    >
                      {data.title}
                    </p>
                  </div>
                }
                secondary={
                  <div>
                    <div
                      className={
                        topicOfTheMonthSelectedDate.date === data.date
                          ? classes.listSubTextSelected
                          : classes.listSubTextNonSelected
                      }
                    ></div>
                  </div>
                }
              />
            </ListItem>
          </div>
        ))}
      </List>
    </div>
  );
}
